export default "<img src=\"\" alt=\"\">"